interface RegionalConfig {
  regionCode: string;
  defaultLocale: string;
  timeZone: string;
}

declare global {
  interface Window {
    regionalConfig?: RegionalConfig;
  }
}

export const regionalConfig: RegionalConfig = window.regionalConfig || {
  regionCode: "CA",
  defaultLocale: "en-CA",
  timeZone: "America/Toronto",
};

export const regionCode = regionalConfig.regionCode || 'CA';
